import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage28.module.css";

export default function LaymanPage28() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>FORCES OF SATURN</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.Saturn_block_main}>
                <div
                  className={`${styles.Saturn_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.Saturn_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/saturn_block1_img.webp"
                    /> */}
                    <img
                      className={styles.Saturn_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_saturn/saturn_block1_img.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div class={styles.layman_yellow_commn_header}>
                        <h2>
                          Saturn's Tapestry: Navigating the Forces of Time and
                          Total Completion
                        </h2>
                      </div>
                      <p>
                        Saturn, a celestial force intricately woven into the
                        fabric of <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and{" "}
                        Archetypal Astrology, emerges as a cosmic weaver, spinning the threads of time and process that define
                        the very essence of existence. Beyond its astronomical
                        significance, Saturn is an Occult force resonating with
                        the laws of entropy, perfectionism, and the meticulous
                        granularization of ideas.
                      </p>
                      <p>
                        Time, the eternal river that shapes the landscapes of
                        our lives, finds its embodiment in the forces of Saturn.
                        The Saturnian energies are akin to the law of entropy, a
                        force that{" "} compels us to recognize{" "}
                        the impermanence of all things. Like an artist chiseling
                        away at stone, Saturn guides us in the meticulous
                        process of sculpting our existence, demanding our
                        attention to every detail as we work towards the final
                        result. It is the force that brings the true weight of
                        our efforts to bear, with the grit to streamline our
                        results but with an unwavering demand for perfection and
                        finality.
                      </p>

                      <p>
                        The artistic metaphor of Saturn is that of a sculptor,
                        each slice into the stone representing a deliberate step
                        towards the realization of a vision. Saturn embodies the
                        completion of grand-scale endeavors, reflecting the
                        arduous but rewarding journey toward that which we wish
                        to attain. The concept of <span><i>"The Great Work,"</i></span>{" "}
                        famously associated with alchemy, finds its resonance in
                        the forces of Saturn—the cosmic weaver overseeing the
                        grand tapestry of the entire Cosmos.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.Saturn_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/saturn_block2_img.webp" /> */}
                    <img
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_saturn/saturn_block2_img.webp`}
                    />
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr}`}>
                    <div className={styles.layman_txt_box_innr}>
                      <p className={styles.one_sqr_bullt}>
                        However, Saturn's influence can be overpowering and
                        costly, demanding our utmost attention and discipline.
                        The Saturnian process represents the most challenging
                        aspects of human existence, where individuals confront
                        the completion of monumental tasks and the realization
                        of long-cherished goals.
                      </p>

                      <p>
                        As an Archetypal instinct, Saturn embodies the{" "}
                        <span><i>"Perfecting Force,"</i></span> a cosmic impulse that
                        compels individuals to strive for excellence and mastery
                        in their endeavors. It is the force that drives us
                        towards <span><i>"Total Completion,"</i></span> pushing us to
                        confront the challenges and demands of the cosmic
                        tapestry, ensuring that we leave no stone unturned in
                        our pursuit of perfection.
                      </p>

                      <p>
                        In conclusion,{" "} Saturn's forces{" "}
                        are not merely confined to the realms of astrology; they
                        extend into the very core of our being, urging us to
                        navigate the cosmic tapestry with patience, discipline,
                        and an{" "} unwavering commitment{" "}
                        to perfection. As seekers embrace the archetypal
                        instinct of Saturn, they embark on a journey of total
                        completion, where the forces of time and meticulous
                        process shape the masterpiece of their existence in the
                        grand mosaic ofthe Cosmos.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.Saturn_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/saturn_block3_img.webp" /> */}
                    <img
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_saturn/saturn_block3_img.webp`}
                    />
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_wrapper} `}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <div class={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <div className={styles.bullet_wrapper}>
                        <p>
                          <strong>Occult Forces:</strong> Saturn is a
                          significant Occult force within <Link href="https://www.divineinfinitebeing.com">the School of Divine
                          Infinite Being</Link> method and{" "} Archetypal Astrology, 
                          representing cosmic energies associated with
                          structure, discipline, and limitations.
                        </p>
                        <p>
                          <strong>Architect of the Cosmos:</strong> Saturn is
                          often referred to as the architect of the cosmos,
                          symbolizing the forces that structure and shape the
                          fabric of reality.
                        </p>
                        <p>
                          <strong>Discipline and Control:</strong> Saturn's
                          forces emphasize discipline and control, urging
                          individuals to establish order and structure in their
                          lives.
                        </p>
                        <p>
                          <strong>Limitations and Boundaries:</strong> Saturn is
                          associated with limitations and boundaries, signifying
                          the constraints individuals encounter in their earthly
                          existence.
                        </p>
                        <p>
                          <strong>Karmic Influence:</strong> Saturn is linked to
                          the concept of karma, representing the consequences of
                          past actions and the need for accountability.
                        </p>
                        <p></p>
                        <p>
                          <strong>Time and Chronos:</strong> Saturn is
                          associated with the concept of time, often represented
                          as the{" "} deity Chronos, embodying the cyclical nature of life and the
                          inevitability of change.
                        </p>
                        <p>
                          <strong>Authority and Hierarchy: </strong> Saturn's
                          energies are aligned with authority and hierarchy,{" "}
                            influencing societal structures{" "}
                          and systems of governance.
                        </p>
                        <p>
                          <strong>Hard Work and Responsibility:</strong>{" "}
                          Individuals influenced by Saturn are often driven by a
                          strong work ethic and a sense of responsibility,{" "}
                            recognizing the importance{" "}
                          of effort and diligence.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.Saturn_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/saturn_block4_img.webp" /> */}
                    <img
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_saturn/saturn_block4_img.webp`}
                    />
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_wrapper} `}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Lessons and Challenges:</b>{" "}
                          Saturn is considered{" "}
                        a taskmaster, bringing forth lessons and challenges that
                        individuals must face and overcome for personal growth.
                      </p>

                      <p>
                        <b>Ringed Planet: </b> Saturn is characterized by its
                        distinctive rings, symbolizing the symbolic constriction
                        and limitations individuals may experience in their life
                        paths.
                      </p>
                      <p>
                        <b>Wisdom through Experience:</b> Saturn is associated
                        with the wisdom gained through experience, emphasizing
                        the value of perseverance and endurance.
                      </p>
                      <p>
                        <b>Elderly Figure:</b> In mythology, Saturn is often
                        portrayed as an elderly figure, symbolizing the
                        accumulation of wisdom and the passage of time.
                      </p>
                      <p>
                        <b>Transcending Materialism:</b> Saturn's energies
                        encourage individuals to transcend materialism and
                        recognize the impermanence of{" "} worldly possessions.
                      </p>
                      <p>
                        <b>Alchemical Transformation:</b> Saturn represents the
                        alchemical process of calcination, signifying the
                        breaking down of old structures to pave the way for
                        transformation and renewal.
                      </p>
                      <p>
                        <b>Archetypal Instinct:</b> As an Archetypal instinct,
                        Saturn embodies the <span><i>"Wisdom of Limitation,"</i></span>{" "}
                        urging individuals to find meaning and growth within the
                        constraints and challenges they face.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                 
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>
                          The Astrological Tarot association for Saturn is
                          <br />
                          The Cosmos. See our alchemical ROTA here
                        </h1>
                      </div>
                    </Link>
                  
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/layman_page28_block1_demo_img_nw_d.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/layman_page28_block2_demo_img_nw_d.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/layman_page28_block3_demo_img_nw_de.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/layman_page28_block4_demo_img_nw_d.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_saturn/layman_page28_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
